import imageCompression from 'browser-image-compression';

import { updateLastPhotoNumber } from '../store/reportDetails';
import { getFileTypeAffix } from './utilities';

export const readSrcFromFiles = (files: File[]) => {
	return files.map(async (file: File) => {
		const compressedFile = await imageCompression(file, { maxSizeMB: 0.3 });
		return new Promise((resolve) => {
				const reader = new FileReader();
				reader.onload = () => resolve({
										refNo: updateLastPhotoNumber(),
										src: reader.result,
										caption: compressedFile.name,
										format: getFileTypeAffix(file.type),
									});
									
				reader.readAsDataURL(compressedFile);
			});
	});
};